<template>
    <v-modal-validated title="Cambiar nombre del expediente"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       :rules="rules"
                       :initial-values="{name}"
                       id="add-attorneys-modal"
                       @closed="closeModal"
                       @accepted="editExpedientName">

        <div class="user-form">
            <div class="form-group">
                <label>Nombre*:</label>
                <Field type="text" name="name" class="form-control" aria-label="Nombre"/>

                <ErrorMessage name="name"/>
            </div>
        </div>
    </v-modal-validated>
</template>

<script>

import VModalValidated from "../../../general/VModalValidated";
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import {updateExpedientName} from "../../../../helpers/requests/RequestsExpedients";

export default {
    name: "ExpedientDetailChangeNameModal",
    components: {VModalValidated, Form, Field, ErrorMessage},
    props: {
        name: {
            type: String,
            required: true,
        },
        expedientId: {
            type: Number,
            required: true,
        },
        expedientClient: {
            type: Object,
            required: true,
        }
    },
    data() {
        const rules = yup.object({
            name: yup.string().required('Debes incluir un nombre').max(50, 'Debe tener como máximo 50 caracteres'),
        });

        return {
            rules,
        }
    },
    mounted() {
    },
    methods: {
        async editExpedientName(data) {
            try {
                await updateExpedientName(this.expedientId, this.expedientClient.id, data);

                this.$store.dispatch('app/setToastMessage', 'Cambios guardados con éxito');

                this.$emit('update-expedient-name');
                this.closeModal();
            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', e.response.data.message);

                this.closeModal();
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    },
}
</script>
